import { create } from "zustand";
import { dealsApi } from "@/api/deals-api";
import { transformDeals } from "@/services/deals-service";
import { Deal, DealTransformed } from "@/lib/schema/deal-schema";

interface PortcoState {
  deals: Record<string, DealTransformed>;
  isLoading: boolean;
  error: string | null;
  fetchDeals: (workspaceId: string) => Promise<void>;
  clearDeals: () => void;
}

export const usePortcoStore = create<PortcoState>((set) => ({
  deals: {},
  isLoading: false,
  error: null,
  
  fetchDeals: async (workspaceId: string) => {
    set({ isLoading: true, error: null });
    
    try {
      // Use getSimpleDealList instead of getDeals for better performance
      const { deals: rawDeals } = await dealsApi.getSimpleDealList(workspaceId);
      const transformedDeals = transformDeals(rawDeals as Deal[]);
      
      set({ 
        deals: transformedDeals, 
        isLoading: false,
        error: null 
      });
    } catch (error) {
      set({ 
        isLoading: false, 
        error: error instanceof Error ? error.message : "Failed to fetch deals" 
      });
    }
  },
  
  clearDeals: () => set({ deals: {}, error: null }),
}));